<div class="pl2">
  <mat-slide-toggle [formControl]="aFormControl" [checked]="defaultValue || schema.default">
    {{schema.title}}
  </mat-slide-toggle>
  @if (schema.description) {
    <p class="small" [innerHTML]="schema.description">
      {{schema.description}}
    </p>
  }
</div>
